export default {
    "name": "HomeSalesOrderDefaults",
    "kind": "HoudiniQuery",
    "hash": "8eed8f1cda4648cb575674d06e3718bf199d0d696e1b7b9c81664d5452387e3d",

    "raw": `query HomeSalesOrderDefaults {
  settingValues {
    home {
      defaultSalesOrderHistoryDateRange
    }
  }
}
`,

    "rootType": "Query",
    "stripVariables": [],

    "selection": {
        "fields": {
            "settingValues": {
                "type": "SettingValues",
                "keyRaw": "settingValues",

                "selection": {
                    "fields": {
                        "home": {
                            "type": "HomeSettingValues",
                            "keyRaw": "home",

                            "selection": {
                                "fields": {
                                    "defaultSalesOrderHistoryDateRange": {
                                        "type": "String",
                                        "keyRaw": "defaultSalesOrderHistoryDateRange",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {}
    },

    "policy": "NetworkOnly",
    "partial": false
};

"HoudiniHash=55113c99099a49bfca02e5579c45c5f2ac46bdd634f2750ce752c143c63d7b26";